module.exports = __webpack_public_path__ + "img/barr-t.3c92c748.png";